import { defineStore } from 'pinia';

// eslint-disable-next-line
import { commonApi } from '@/service/api/common';

import fleetMineCenterDefault from './defaultConfig/fleetMineCenter.json';
import fleetSettingsDefault from './defaultConfig/fleetSettings.json';
import onShelfDefault from './defaultConfig/onShelf.json';
import driverMarketDefault from './defaultConfig/driverMarket.json';
import vehicleDetailDefault from './defaultConfig/vehicleDetail.json';
import driverMineCenterDefault from './defaultConfig/driverMineCenter.json';
import driverSettingsDefault from './defaultConfig/driverSettings.json';
import driverResumeDefault from './defaultConfig/driverResume.json';
import vehicleMarketDefault from './defaultConfig/vehicleMarket.json';

export const useCommonStore = defineStore({
  id: 'common',
  state: () => ({
    roleInfo: {},
    // 登录校验 重复校验
    loginHasExit: false,
    // 响应式
    currentWidth: 0,
    billSwitch: false,
    currencyUnit: '',

    configFleetMineCenter: {},
    configFleetSettings: {},
    configDriverMarket: {},
    configOnShelf: {},
    configVehicleDetail: {},

    configDriverMineCenter: {},
    configDriverSettings: {},
    configDriverResume: {},
    configVehicleMarket: {},
    configVehicleBanner: [],

    configFleetMsgForFe: {},
    configDriverMsgForFe: {},

    legalNoticeInfo: {},

    driverBehavior: {}
  }),
  actions: {
    async getTimeOrUnit(params: any) {
      const { data } = await commonApi.getTimeOrUnit(params);

      this.currencyUnit = data?.currency_unit || 'R$';
    },
    async runCheckRole(params: any) {
      const { data } = await commonApi.runCheckRole(params);

      this.roleInfo = data || {};
    },
    async getBillSwitch(params: any) {
      const { data } = await commonApi.getBillSwitch(params);
      const functionSet: any = {};

      data &&
        data.forEach((item: any) => {
          functionSet[item.feature_name] = item.switch;
        });
      this.billSwitch = functionSet?.new_cash_flow;
    },
    async getConfigFleetMineCenter(params: any) {
      const { data } = await commonApi.getConfigFleetMineCenter(params);

      this.configFleetMineCenter = data || fleetMineCenterDefault;
    },
    async getConfigFleetSettings(params: any) {
      const { data } = await commonApi.getConfigFleetSettings(params);

      this.configFleetSettings = data || fleetSettingsDefault;
    },
    async getConfigOnShelf(params: any) {
      const { data } = await commonApi.getConfigOnShelf(params);

      this.configOnShelf = data || onShelfDefault;
    },
    async getConfigDriverMarket(params: any) {
      const { data } = await commonApi.getConfigDriverMarket(params);

      this.configDriverMarket = data || driverMarketDefault;
    },
    async getConfigVehicleDetail(params: any) {
      const { data } = await commonApi.getConfigVehicleDetail(params);

      this.configVehicleDetail = data || vehicleDetailDefault;
    },

    async getConfigDriverMineCenter(params: any) {
      const { data } = await commonApi.getConfigDriverMineCenter(params);

      this.configDriverMineCenter = data || driverMineCenterDefault;
    },
    async getConfigDriverSettings(params: any) {
      const { data } = await commonApi.getConfigDriverSettings(params);

      this.configDriverSettings = data || driverSettingsDefault;
    },
    async getConfigDriverResume(params?: any) {
      const { data } = await commonApi.getConfigDriverResume(params);

      this.configDriverResume = data || driverResumeDefault;
    },
    async getConfigVehicleMarket(params: any) {
      const { data } = await commonApi.getConfigVehicleMarket(params);

      this.configVehicleMarket = data || vehicleMarketDefault;
    },
    async getConfigVehicleBanner(params: any) {
      const { data } = await commonApi.getConfigVehicleBanner(params);

      this.configVehicleBanner = data?.resource || [];
    },

    async getConfigFleetMsgForFe(params?: any) {
      const { data } = await commonApi.getConfigFleetMsgForFe(params);

      this.configFleetMsgForFe = data;
    },
    async getConfigDriverMsgForFe(params?: any) {
      const { data } = await commonApi.getConfigDriverMsgForFe(params);

      this.configDriverMsgForFe = data;
    },

    async checkLegalNotice(params: any) {
      const { data } = await commonApi.checkLegalNotice(params);

      this.legalNoticeInfo = data?.[0] || {};
    },
    async agreeLegalNotice(params: any) {
      await commonApi.agreeLegalNotice(params);
    },

    async getDriverBehavior(params: any) {
      const { data } = await commonApi.getDriverBehavior(params);

      this.driverBehavior = data || {};
    },
    async saveDriverBehavior(params: any) {
      await commonApi.saveDriverBehavior(params);
    },

    async getPictureAuditStatus(params: any) {
      const { data } = await commonApi.getPictureAuditStatus(params);

      return data;
    }
  }
});
